import { FormikValues } from 'formik';
import { create } from 'zustand';
import { PlatformType } from '~/screens/ManagePlatforms/common';

export interface Props {
  values: FormikValues;
  setValues: (values: FormikValues) => void;
  platform: PlatformType;
  setPlatform: (platform: PlatformType) => void;
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}

const initialValues = {
  instagram: '',
  tiktok: '',
  snapchat: '',
  youtube: '',
};

export const useAddNewPlatformsStore = create<Props>((set) => ({
  values: initialValues,
  setValues: (values) => set(() => ({ values })),
  platform: undefined,
  setPlatform: (platform) => set(() => ({ platform })),
  isModalOpen: false,
  setIsModalOpen: (isOpen) => {
    if (isOpen) return set({ isModalOpen: true });

    return set(() => ({
      isModalOpen: false,
      values: initialValues,
      platform: undefined,
    }));
  },
}));
